import { QueryClient } from '@tanstack/react-query';
import { HOUR_IN_MS } from '@/constants/date.constants';

export const multiSuggestQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 24 * HOUR_IN_MS, // TEMPORARY! Will be fixed within caching strategy updates
      staleTime: Infinity,
    },
  },
});
